module.exports = __webpack_public_path__ + "static/img/yshh1-7.667269e.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/yshh1-7.png
// module id = 783
// module chunks = 0